/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MarkAllNotificationsAsRead200Response
 */
export interface MarkAllNotificationsAsRead200Response {
    /**
     * 
     * @type {number}
     * @memberof MarkAllNotificationsAsRead200Response
     */
    count?: number;
}

/**
 * Check if a given object implements the MarkAllNotificationsAsRead200Response interface.
 */
export function instanceOfMarkAllNotificationsAsRead200Response(value: object): value is MarkAllNotificationsAsRead200Response {
    return true;
}

export function MarkAllNotificationsAsRead200ResponseFromJSON(json: any): MarkAllNotificationsAsRead200Response {
    return MarkAllNotificationsAsRead200ResponseFromJSONTyped(json, false);
}

export function MarkAllNotificationsAsRead200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MarkAllNotificationsAsRead200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'] == null ? undefined : json['count'],
    };
}

export function MarkAllNotificationsAsRead200ResponseToJSON(json: any): MarkAllNotificationsAsRead200Response {
    return MarkAllNotificationsAsRead200ResponseToJSONTyped(json, false);
}

export function MarkAllNotificationsAsRead200ResponseToJSONTyped(value?: MarkAllNotificationsAsRead200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
    };
}

